
export const transferrableAttachments = <const>['poster'];
export type TransferrableAttachment = typeof transferrableAttachments[number];

/**
 * The `poster` and `prproj` is only included to maintain backward compatibility for third-party integration.
 */
export const attachmentTypes = <const>[
  'prproj',
  'drp',
  'image',
  'subtitle',
  'file',
  'sequence',
  'timeline',    // attachment for mimir cutter sequence timeline
  ...transferrableAttachments,
];
export type AttachmentType = typeof attachmentTypes[number];

/**
 * Thumbnail property does the same thing as poster, but included to maintain backward compatibility.
 */
export const attachmentRoles = <const>['thumbnail', 'poster', 'subtitle', 'file', 'render_source'];
export type AttachmentRole = typeof attachmentRoles[number];

export const SEQUENCE_TIMELINE_ATTACHMENT_FILE_NAME_LEGACY = 'sequence.mseq';

/**
 * Default file name for cutter timeline attachments.
 * The backend also accepts any timeline format with `.json` filename.
 */
export const DEFAULT_TIMELINE_ATTACHMENT_FILE_NAME = 'timeline.json';

export type ItemAttachmentByRoleParams = { role: AttachmentRole };
export type ItemAttachmentByFileNameParams = { fileName: string };

export type ItemAttachmentQueryParams =
  | ItemAttachmentByRoleParams
  | ItemAttachmentByFileNameParams;

export interface MxcoderItemAttachmentResponse {
  url: string;
  type: AttachmentType;
}

export type ItemAttachmentsListQueryParams = {
  role: AttachmentRole | undefined;
  fileName: string | undefined;
};
